import { t } from 'i18next';
import * as yup from 'yup';

import { createPasswordInputSchema } from 'core/components/form';

export const loginSchema = yup
  .object({
    email: yup
      .string()
      .required(
        t('errors.validation.isRequired', {
          name: t('pages.login.fields.email'),
        })
      )
      .email(
        t('errors.validation.isInvalid', {
          name: t('pages.login.fields.email'),
        })
      ),
    password: createPasswordInputSchema({
      name: t('pages.login.fields.password'),
    }),
  })
  .required();

export type LoginFormData = yup.InferType<typeof loginSchema>;
